import { TICKER_LINK_STYLE } from "../utils/stockDashboardNav";

/**
 * Symbole cliquable → Stock Dashboard (/marketflow/ticker/:symbol).
 * stopPropagation pour usage dans lignes/cartes cliquables.
 */
export default function TickerSymbolLink({
  symbol,
  onOpen,
  children,
  style = {},
  title = "Voir le dashboard titre",
  truncate = 14,
}) {
  const label = children ?? symbol;
  if (!symbol) return <span style={style}>{label}</span>;
  const display =
    typeof label === "string" && truncate && label.length > truncate
      ? `${label.slice(0, truncate)}…`
      : label;

  if (!onOpen) {
    return <span style={style}>{display}</span>;
  }

  return (
    <button
      type="button"
      title={title}
      onClick={(e) => {
        e.stopPropagation();
        onOpen(symbol);
      }}
      style={{ ...TICKER_LINK_STYLE, ...style }}
    >
      {display}
    </button>
  );
}
